let searchTimer;

function searchTextFocusoutHandler() {
    const selector = '.textbox-search';
    $(selector).off('focusout');
    $(selector).on('focusout', () => {
        setTimeout(() => {
            $('.search-result').css('display', 'none');
        }, 400);
    });
}

function searchTextKeyupHandler() {
    const selector = '.textbox-search';
    $(selector).off('keyup');
    $(selector).on('keyup', function() {
        clearTimeout(searchTimer);

        const find = $(this).val().toString();
        if (find.length < 2) {
            $('.search-result').css('display', 'none');
            return;
        }

        searchTimer = setTimeout(search, 300);
    });
}

function search() {
    const textBox = $('.textbox-search');
    const find = textBox.val().toString();
    let findCode = '';
    for (let i = 0; i < find.length; i++) {
        findCode += find.charCodeAt(i) + ',';
    }
    findCode = findCode.substring(0, findCode.length - 1);

    $.post('/_search.ashx?rv=' + Date.now(),
        {
            find: findCode + '',
        },
        (data, status) => {
            if (data.itemsCount === 0) {
                $('.search-result').css('display', 'none');
                return;
            }

            if (data.items == null) {
                return;
            }

            let sb = '';
            for (const item of data.items) {
                sb += '<a href=\'';
                sb += item.link;
                sb += '\'>';
                sb += '<img src=\'' + item.image + '\' />';
                sb += '<div><p>';
                sb += item.title;
                sb += '</p><p>';
                sb += item.category;
                sb += '</p></div></a>';
            }
            sb += '</ul>';
            $('.search-result').html(sb);
            $('.search-result').css('display', 'block');
        });
}

const initSearch = () => {
    searchTextFocusoutHandler();
    searchTextKeyupHandler();
};

export {
    initSearch
};
